// extracted by mini-css-extract-plugin
export default {"back-button-container":"BackButton_back-button-container__UvnqN","back-button-span":"BackButton_back-button-span__NXrBx","back-button-icon":"BackButton_back-button-icon__GXWcO"};